import TeaserTile from '../components/TeaserTile/TeaserTile';
import TravelAreaTeaserTile from "../components/TeaserTile/TravelAreaTeaserTile";
import ItineraryTeaserTile from "../components/TeaserTile/ItineraryTeaserTile";

/**
 * @param {string} contentType
 * @return TeaserTile
 */
export default function getTeaserTile(contentType) {
	switch (contentType) {
        case 'travelArea':
            return TravelAreaTeaserTile;
        case 'itinerary':
            return ItineraryTeaserTile;
        default:
			return TeaserTile;
	}
}


// WEBPACK FOOTER //
// ./src/services/contentType.js